export const addNewDefaultDepartment= (department) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();

        const departments = getState().admin.homepage[department];
        let order = (departments === undefined || departments === null) ? 0 : departments.length;

        const departmentsRef = firebase.ref().child(`departments/${department}`);
        const departmentKey = departmentsRef.push();  
        departmentKey.set({
            type : 'normal',
            name : {
                en : 'New Department',
                ko : '새로운 부서'
            }, 
            content : {
                en : 'New Content',
                ko : '내용입니다'
            },
            order 
        })
    }
}

export const addNewDefaultDepartmentCard= (successFunc, newOrder) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();

        const departmentsRef = firebase.ref().child(`departments/cards`);
        const departmentKey = departmentsRef.push();  
        console.log(departmentKey);
        departmentKey.set({
            name : {
                en : 'New Department',
                ko : '새로운 부서'
            }, 
            content : {
                en : 'New Content',
                ko : '내용입니다'
            },
            order : newOrder
        })

        if(successFunc) successFunc(departmentKey.key);
    }
}


export const updateDepartment = (department, id, data) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const departmentRef = firebase.ref().child(`departments/${department}/${id}`); 
        
        let stripped = {...data};
        delete stripped['id'];

        departmentRef.update({
            ...stripped
        }, () => {
        })
            .catch(e => {
                console.log(e);
            })
    }
}

export const removeDepartment = (dbPath, storagePath, data) => {
    return (dispatch, getState, getFirebase) => {
        const result = global.confirm('정말로 삭제하시겠습니까?');
        if(result) {
            const firebase = getFirebase();

            const departmentRef = firebase.ref().child(`departments/${dbPath}`); 
            const itemRef = firebase.ref().child(`departments/${dbPath}/${data.id}`); 

            itemRef.remove(() => {
                let dep = getState()['admin']['homepage'][`${dbPath}`];

                if(dbPath !== 'cards'){
                    for(let i = 0; i < dep.length; ++i) {
                        departmentRef.child(`${dep[i].id}`).update({order : i });
                    }
                }
            })
                .catch(e => {
                    console.log(e);
                })

            const imageRef = firebase.storage().ref(`${storagePath}/${data.id}.jpg`);
            imageRef.delete();

            const subfixPath = data.subfix ? `_${data.subfix}` : '';

            if(data.count) {
                for(let i = 0; i < data.count; ++i) {
                    const imageRef = firebase.storage().ref(`${storagePath}/${data.id}${subfixPath}_${i}.jpg`); 
                    imageRef.delete();
                }
            }
        }
    }
}

export const departmentDataOrderSwitch = (dbPath, aIndex, bIndex) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const dataArray = getState().admin.homepage[dbPath];

        if(aIndex < 0 || aIndex > dataArray.length - 1 ||
            bIndex < 0 || bIndex > dataArray.length - 1) { 
                return;
        }
        let aData = dataArray[aIndex];
        const aId = aData.id;
        delete aData['id'];

        let bData = dataArray[bIndex];
        const bId = bData.id;
        delete bData['id'];

        const newAOrder = bData.order;
        const newBOrder = aData.order;

        aData.order = newAOrder;
        bData.order = newBOrder;

        const dataArrayRef = firebase.ref().child(`departments/${dbPath}/`); 
        dataArrayRef.update({
            [aId] : {
                ...aData
            },
            [bId] : {
                ...bData
            }
        })
    }
}

export const departmentCardDataOrderSwitch = (aIndex, bIndex, dataArray) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();

        if(aIndex < 0 || aIndex > dataArray.length - 1 ||
           bIndex < 0 || bIndex > dataArray.length - 1 ||
           dataArray.length === 1) {
            return;
        }

        let aData = dataArray[aIndex];
        const aId = aData.id;
        delete aData['id'];

        let bData = dataArray[bIndex];
        const bId = bData.id;
        delete bData['id'];

        const newAOrder = bData.order;
        const newBOrder = aData.order;

        aData.order = newAOrder;
        bData.order = newBOrder;

        const aDataRef = firebase.ref().child(`departments/cards/${aId}`);
        aDataRef.update({
            ...aData
        });
        const bDataRef = firebase.ref().child(`departments/cards/${bId}`);
        bDataRef.update({
            ...bData
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/Admin/HomepageManager/actions/departmentActions.js